import {BasePqmFieldValue} from "./BasePqmFieldValue";

export class PqmFieldEmpty extends BasePqmFieldValue {
	public message: string = "";

	beforeIndex() {
		this.muAppendContent(`<span mu-id="message"></span>`);
	}

	afterIndex() {
		this.ui.message.innerText = this.message + " " + this.paramType + " " + this.control;
	}
}